module.exports = __webpack_public_path__ + "img/speakers.da5e5c28.svg";